import React from 'react';
import WhiteCard2 from "../../assets/images/hackedouter.png";
import Hackedelipse from "../../assets/images/lefteffect2.png";
import lefteffect4 from "../../assets/images/lefteffect5.png";
import bgeffect1 from "../../assets/images/bgeffect1.png";

import bg7 from "../../assets/images/shadowline2.png";
import RotatingCirclesWithIcons from '../ui/Animation.tsx';
import ContactArmory from '../ui/ContactArmory.tsx';
import CustomersFeddback from './CustomersFeddback.tsx';
import useFlickerEffect from '../../hooks/useFlickerEffect.ts';
import AttackAnim from "../../assets/images/AttackAnimFinal.gif"
import About from './About.tsx';
import Career from './career.tsx';
import ContactUs from './ContactUs.tsx'



const Strategy = () => {
    const activeClass = useFlickerEffect();
    return (
        <>
            <section id='strategysection' className='relative overflow-hidden lg:overflow-visible '>
                <img src={Hackedelipse} className={` xl:block absolute left-0 top-[350px] lg:block hidden md:hidden ${activeClass && "animate-flicker"}`} alt="elipse" />
                <img src={bgeffect1} className={`  xl:block absolute left-0  block lg:hidden md:hidden top-[725px] ${activeClass && "animate-flicker"}`} alt="elipse" />
                <img src={lefteffect4} className={`  xl:block absolute left-0 bottom-[-768px] lg:bottom-[-300px] hidden lg:block md:block ${activeClass && "animate-flicker"}`} alt="elipse" />
                <img src={bgeffect1} className={`  xl:block absolute left-0  block lg:hidden md:hidden bottom-[15px] ${activeClass && "animate-flicker"}`} alt="elipse" />
                <div className='relative' >
                    <div className='container' >
                        <div>
                            <div className="relative text-nowrap md:after:absolute md:after:bg-[url('../src/assets/images/strategylight.png')] lg:after:absolute lg:after:bg-[url('../src/assets/images/strategylight.png')] md:after:top-0 md:after:left-0 md:after:right-0 md:after:bottom-0 lg:after:top-0 lg:after:left-0 lg:after:right-0 lg:after:bottom-0 z-30 md:after:bg-contain md:after:bg-top md:after:bg-no-repeat lg:after:bg-contain lg:after:bg-top lg:after:bg-no-repeat h-full ">
                                <h2 style={{ textShadow: "0px 0px 20px #2972D7" }} className=' text-white font-gothicproMedium text-[28px]  md:text-[32px] lg:text-[40px] text-center 
                                drop-shadow-custom pt-10 md:pt-20 lg:pt-[145px]  relative z-20 lg:bottom-[45px]'>// DEFENSE STRATEGY</h2>
                                <div className='relative lg:-top-32 md:bottom-[97px] bottom-[32px]'>
                                    <RotatingCirclesWithIcons />
                                </div>
                            </div>
                        </div>
                    </div>
                    <img className={`hidden lg:block absolute top-[10%] ${activeClass && 'animate-flicker'} min-[1324px]:top-[0%] right-0`} src={bg7} alt="flickerimg" />
                </div>
                <CustomersFeddback />
                <About />
                <Career />
                
                {/* Mobile and Tablet Layout */}
                <div className="lg:hidden">
                    <div className="container pt-10">
                        <div className="flex flex-col items-center text-center">
                            <p className='text-[#E2EEFF] pb-4 text-[20px] font-medium font-gothicproMedium leading-[100%] mb-4' >At the end of the day, <br className='md:hidden block'></br>only one question matters:</p>
                            <h3 className='drop-shadow-custom_red text-white text-[28px] md:text-[32px] leading-[100%] font-gothicproMedium mb-8' style={{ textShadow: "0px 0px 20px #FF0000" }} >// CAN YOU BE HACKED?</h3>
                        </div>
                    </div>
                    <ContactUs />
                    <div className="container">
                        <div className="flex flex-col items-center">
                            <img className='w-[550px] h-[407px] relative' src={AttackAnim} alt="hacked" />
                        </div>
                    </div>
                </div>

                {/* Desktop Layout */}
                <div className="hidden lg:block relative after:absolute after:top-[-93%] after:right-0 after:w-[500px] after:h-[800px] after:bg-no-repeat after:bg-[url('../src/assets/images/bgeffectcircleshadow.png')]">
                    <div id='contactsection' className='container'>
                        <div className="flex flex-col gap-7 lg:gap-[60px] lg:mt-[120px]">
                            <div className='grid place-items-center lg:grid-cols-2 gap-10 items-center w-full relative z-10'>
                                <div className='w-full flex flex-col items-center'>
                                    <div>
                                        <p className='text-[#E2EEFF] pb-4 text-[20px] font-medium font-gothicproMedium leading-[110%] text-center lg:text-left lg:pr-[120px]'>At the end of the day, only one question matters:</p>
                                        <h3 className='drop-shadow-custom_red text-white text-[28px] lg:text-[40px] leading-[100%] font-gothicproMedium text-center lg:text-left pr-[100px]' style={{ textShadow: "0px 0px 20px #FF0000" }} >// CAN YOU BE HACKED?</h3>
                                    </div>
                                </div>
                                <img className='w-[441px] h-[327px]' src={AttackAnim} alt="hacked" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='lg:block hidden mt-[50px]'>
                <ContactUs />

                </div>
            </section>
        </>
    )
}

export default Strategy